(function () {

  const emotions = {

    alegria: {
      title: "Alegría",
      description: "La alegría aparece cuando algo importante se cumple.",
      prompt: "¿Qué ha sido bonito hoy?"
    },

    tristeza: {
      title: "Tristeza",
      description: "La tristeza ayuda a procesar cambios o pérdidas.",
      prompt: "¿Qué necesitas aceptar?"
    },

    miedo: {
      title: "Miedo",
      description: "El miedo aparece ante la incertidumbre.",
      prompt: "¿Qué te preocupa?"
    },

    ira: {
      title: "Ira",
      description: "La ira aparece cuando se cruzan límites.",
      prompt: "¿Qué límite necesitas poner?"
    },

    sorpresa: {
      title: "Sorpresa",
      description: "La sorpresa te prepara para lo inesperado.",
      prompt: "¿Qué te ha sorprendido?"
    },

    asco: {
      title: "Asco",
      description: "El asco ayuda a rechazar lo dañino.",
      prompt: "¿Qué quieres evitar?"
    }

  };

  function init() {

    const title = document.getElementById("brainyEmotionTitle");
    const description = document.getElementById("brainyEmotionDescription");
    const prompt = document.getElementById("brainyPrompt");
    const card = document.getElementById("brainyEmotionCard");

    const sectors = document.querySelectorAll(".brainy-sector");
    const wheel = document.querySelector(".brainy-wheel-svg");

    if (!sectors.length) return;

    // Trigger the entrance spin once, when the wheel scrolls into view.
    if (wheel && !wheel.dataset.brainyObserved) {
      wheel.dataset.brainyObserved = "true";

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              wheel.classList.add("brainy-in-view");
              observer.unobserve(wheel);
            }
          });
        }, { threshold: 0.3 });

        observer.observe(wheel);
      } else {
        // Fallback for very old browsers without IntersectionObserver.
        wheel.classList.add("brainy-in-view");
      }
    }

    function update(emotion) {

      const data = emotions[emotion];
      if (!data) return;

      title.textContent = data.title;
      description.textContent = data.description;
      prompt.textContent = data.prompt;

      sectors.forEach(s => s.classList.remove("is-active"));
      document.querySelectorAll(`.brainy-sector[data-emotion="${emotion}"]`)
        .forEach(s => s.classList.add("is-active"));

      if (card) {
        card.classList.remove("brainy-pulse");
        void card.offsetWidth; // restart animation
        card.classList.add("brainy-pulse");
      }
    }

    sectors.forEach(sector => {

      const emotion = sector.getAttribute("data-emotion");

      sector.addEventListener("mouseenter", () => update(emotion));
      sector.addEventListener("click", () => update(emotion));
      sector.addEventListener("focus", () => update(emotion));

    });
  }

  // Run immediately if the DOM is already parsed (e.g. script injected
  // dynamically by the Shopify theme editor's section re-render), or wait
  // for DOMContentLoaded on a normal first page load.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init whenever Shopify's theme editor re-renders this section,
  // since AJAX re-renders don't re-fire DOMContentLoaded.
  document.addEventListener("shopify:section:load", init);

})();